<template>
  <div class="pnlDialogFull" v-show="show" style="animation-duration:0.2s;">
    <div class="pnlDialogGray">
      <div class="pnlDialogOneBtn">
        <label class="lblWarning" v-html="msgWarning"></label>
        <button class="btnConfirm" @click="BtnClick">{{btnTxt}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DialogWarning",
  props: {
    show: Boolean,
    msgWarning: String,
    btnTxt: String,
  },
  data() {
    return {
    };
  },
  methods: {
    BtnClick(){
      this.$emit("btn-click");
    }
  },
};
</script>